
window.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.active-filters--container')
  let pathname = window.location.pathname

  if( pathname[0] === '/') {
    pathname = pathname.slice(1)
  }

  let queryFilter = pathname.split('/')[2]

  if( !queryFilter ) return

  if( queryFilter[0] === '+' ) {
    queryFilter = queryFilter.slice(1)
  }

  const filters = queryFilter.split('+')

  if( !container ) throw new Error('Element container must to be defined')

  function onDeleteFilter(filter) {
    const newQueryFilter = filters.filter( (f) => f !== filter).join('+')

    const url = window.location.pathname.split('/').slice(0, 3).join('/') + '/' + newQueryFilter
    console.log({ url })
    window.location.replace(url)
  }

  filters.forEach( filter => {
    const filterTag = document.querySelector('p')

    filterTag.onclick = () => onDeleteFilter(filter)

    filterTag.classList.add('active-filters')
    filterTag.textContent = filter.replaceAll('_', ' ') + ' X'

    container.append(filterTag)
  })
})

window.addEventListener('DOMContentLoaded', () => {
  const dropdownBtn = document.querySelector('#dropdown-filter')
  const filterContainer = document.querySelector('.filter-container')

  if( dropdownBtn ) {
    dropdownBtn.onclick = function() {
      filterContainer.classList.toggle('active')

      if( filterContainer.classList.contains('active') ) {
        dropdownBtn.textContent = 'Ocultar filtros'
      } else {
        dropdownBtn.textContent = 'Mostrar filtros'
      }
    }
  }
})
